import { render, staticRenderFns } from "./DepositGood.vue?vue&type=template&id=36319ec2&"
import script from "./DepositGood.vue?vue&type=script&lang=js&"
export * from "./DepositGood.vue?vue&type=script&lang=js&"
import style0 from "./DepositGood.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports